import React, { useMemo, memo } from 'react';

import Comment from '../../../../components/Comment';

const NoteItem = props => {
  const {
    description,
    createdAt,
    courseId,
    lessonId,
    courseName,
    lessonOrder,
  } = props;

  const name = useMemo(() => courseName || '', [courseName]);
  const order = useMemo(() => {
    if (lessonOrder) {
      const orderString = String(lessonOrder);
      if (orderString.includes('.')) {
        const [moduleOrder, lessonScopedOrder] = orderString.split('.');
        return `${moduleOrder}.${parseInt(Number(lessonScopedOrder), 10)}`;
      }
      return lessonOrder;
    }
    return '';
  }, [lessonOrder]);

  return (
    <Comment
      className="padded"
      title={`${order && `Aula ${order} - `}${name}`}
      msg={description}
      date={createdAt}
      url={`/course/${courseId}/${lessonId}`}
    />
  );
};

export default memo(NoteItem);
